import api, { UPLOAD_REQUEST_TIMEOUT_MS } from "./api";

interface HelpRequestData {
  requestType: string;
  title: string;
  description: string;
  photo?: File;
}

export const helpService = {
  submitHelpRequest: async (data: HelpRequestData) => {
    const formData = new FormData();
    formData.append("requestType", data.requestType);
    formData.append("title", data.title);
    formData.append("description", data.description);
    if (data.photo) {
      formData.append("photo", data.photo);
    }
    const response = await api.post("/core/help-request/", formData, {
      timeout: UPLOAD_REQUEST_TIMEOUT_MS,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
};
